// api地址前缀
const BASE_URL = process.env.BASE_URL;

export default ((config) => {
  return Object.keys(config).reduce((copy, name) => {
    copy[name] = `${BASE_URL}${config[name]}`;
    return copy;
  }, {});
})({
  login: '/login/index',
  getAccessToken: '/authenticate/accessToken',
  getQrcodeIndex: '/qrcode/index',
  getRecordList: '/record/list',
  getNetworkList: '/network/trafficsite',
  getNetworkDetailV2: '/network/trafficsite/detailv2',
  getNetworkDetailV3: '/network/trafficsite/detailv3',
  getNetworkDetail: '/network/trafficsite/detail',
  getLoungeDetail: '/network/trafficsite/loungecode',
  getMealNetworkList: '/mealcoupon/network/airport/list',
  getMealNetworkDetail: '/mealcoupon/network/airport/detail',
  getMealProDetail: '/mealcoupon/network/restaurant/detail',
  getflushQrcode: '/qrcode/flushQrcode',
  getRecord: '/qrcode/getRecord',
  getCipInfo: '/cip/index', // 获取cip信息
  cipLogin: '/cip/login', // cip登录
  cipNetworkList: '/cip/network/trafficsite',
  buyPoint: '/buyPoint/saveOrder',
  mealAccess: '/coupon/access',
  mealDetail: '/coupon/index',
  mealRefreshQrcode: '/coupon/qrCode/refresh',
  cipnetworkDetail: '/cip/network/cipDetail', //获取单个机场可以CIP数据
  getCipFlushQrcode: '/cip/flushQrcode',
  getNetworkTrainList: '/network/train/list', // 车次列表
  getNetworkRailCombosetList: '/network/rail/comboset/list', // 高铁套餐接口
  getBarcode: '/qrcode/flushBarcode', // 条形码数字
});
